import { JxtEventColorInfos } from '@jooxter/utils';
import { clsx } from 'clsx';
import JxtIconButton from '../JxtIconButton';
import { JxtIconButtonSizeEnum, JxtIconButtonTypeEnum } from '../JxtIconButton/types';
import { BookingDisplayModeEnum, IJxtCalendarEvent } from './types';
import { getClassNames } from './styles';
import { Wrapper } from './wrapper';

const JxtCalendarEvent = ({
  id,
  mode = BookingDisplayModeEnum.Regular,
  color,
  hours,
  text,
  notSelected,
  isValidated,
  nbAttendees = 0,
  isRecurrence = false,
  isDeclined = false,
  optionIconsList = [],
  onClickEvent,
  onClickEdit,
  onClickCheckIn,
  onClickCheckOut,
  onClickDelete,
}: IJxtCalendarEvent) => {
  const bgColor = notSelected
    ? clsx('bg-transparent', JxtEventColorInfos[color].hoverBgColor)
    : !isValidated && typeof isValidated === 'boolean'
      ? JxtEventColorInfos[color].pendingColor
      : JxtEventColorInfos[color].bgColor;
  const borderColor = notSelected
    ? clsx('border-transparent', JxtEventColorInfos[color].borderColor)
    : !isValidated && typeof isValidated === 'boolean'
      ? 'border-none'
      : JxtEventColorInfos[color].borderColor;
  const textColor = JxtEventColorInfos[color].textColor;
  const hatchClasses = !isValidated
    ? `${JxtEventColorInfos[color].bgColor}`
    : `${JxtEventColorInfos[color].squareColor}`;

  const hatchPattern = !isValidated
    ? 'bg-[linear-gradient(45deg,rgba(255,255,255,0.95)_10%,transparent_30%,transparent_50%,rgba(255,255,255,0.95)_30%,rgba(255,255,255,0.95)_60%,transparent_80%,transparent_100%)] bg-size-[6px_6px]'
    : '';

  return (
    <div
      className={clsx(
        'w-full rounded-lg gap-2 hover:cursor-pointer border flex overflow-hidden',
        bgColor,
        borderColor,
        getClassNames(mode, isValidated)
      )}
      onClick={onClickEvent ? () => onClickEvent(id) : undefined}
    >
      <Wrapper isValidated={isValidated} hatchPattern={hatchPattern} hatchClasses={hatchClasses}>
        <div
          className={clsx(
            'flex text-body-s font-normal',
            textColor,
            isDeclined ? 'line-through' : '',
            [BookingDisplayModeEnum.Compact, BookingDisplayModeEnum.NoPadding].includes(mode)
              ? 'flex-col'
              : 'gap-2 items-center',
            typeof isValidated === 'boolean' && mode === BookingDisplayModeEnum.Compact ? 'py-1' : ''
          )}
        >
          {hours && <span>{hours}</span>}
          <span className="truncate">{text}</span>
        </div>
        {(isRecurrence || nbAttendees > 0) && (
          <div className={clsx('flex items-center gap-2', textColor)}>
            {isRecurrence && <i className="fas fa-arrows-rotate fa-xs" />}
            {nbAttendees > 0 && (
              <div className="flex items-center gap-1">
                <i className="fas fa-user fa-xs" />
                <span className="text-body-xs font-normal">{nbAttendees}</span>
              </div>
            )}
          </div>
        )}
        {optionIconsList.length > 0 && (
          <div className="items-center flex gap-1 shrink-0">
            {optionIconsList.map((icon, i) => (
              <img key={`${icon}-${i}`} src={icon} height="16" width="16" />
            ))}
          </div>
        )}
        {(onClickCheckIn || onClickCheckOut || onClickEdit || onClickDelete) && (
          <div className={clsx('flex grow items-center', mode === BookingDisplayModeEnum.Compact ? '' : 'justify-end')}>
            {onClickCheckIn && (
              <JxtIconButton
                icon="check"
                type={JxtIconButtonTypeEnum.Light}
                size={JxtIconButtonSizeEnum.S}
                onClick={onClickCheckIn}
              />
            )}
            {onClickCheckOut && (
              <JxtIconButton
                icon="arrow-right-from-bracket"
                type={JxtIconButtonTypeEnum.Light}
                size={JxtIconButtonSizeEnum.S}
                onClick={onClickCheckOut}
              />
            )}
            {onClickEdit && (
              <JxtIconButton
                icon="pen"
                type={JxtIconButtonTypeEnum.Light}
                size={JxtIconButtonSizeEnum.S}
                onClick={onClickEdit}
              />
            )}
            {onClickDelete && (
              <JxtIconButton
                icon="trash"
                type={JxtIconButtonTypeEnum.Light}
                size={JxtIconButtonSizeEnum.S}
                onClick={onClickDelete}
              />
            )}
          </div>
        )}
      </Wrapper>
    </div>
  );
};

export default JxtCalendarEvent;
